export default "__VITE_ASSET__KDEfK3XF__"